import slug from 'slug';
import copy from 'copy-to-clipboard';
import { nanoid } from 'nanoid';

import uEmojiParser from 'universal-emoji-parser';

export function capitalizeFirstLetter(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

export function slugify(string) {
    return string ? slug(string) : '';
}

export function truncate(str, count = 20, splitType = 'word') {
    return splitType === 'word' ? (str || '').split(' ').splice(0, count).join(' ') : (str || '').slice(0, count);
}

export function copyToClipboard(text) {
    return copy(text);
}

export function textToColor(str) {
    str = `${str}`;
    let hash = 0;
    for(let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for(let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += (`00${value.toString(16)}`).substr(-2);
    }
    return color;
}

export function hex2rgb(hex) {
	if(hex.length !== 7) { // #333 format
		hex = `#${hex.slice(1, 2).repeat(2)}${hex.slice(2, 3).repeat(2)}${hex.slice(-1).repeat(2)}`;
	}
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    // return {r, g, b}
    return { r, g, b };
}

// from: https://gist.github.com/kongchen/941a652882d89bb96f87
export function utf8To16(input) {
    const _escape = s => {
        function q(c) {
            const e = c.charCodeAt();
            return `%${(e < 16 ? '0' : '')}${e.toString(16).toUpperCase()}`;
        }
        return s.replace(/[\x00-),:-?[-^`{-\xFF]/g, q);
    };
    try {
        return decodeURIComponent(_escape(input));
    } catch (URIError) {
        // include invalid character, cannot convert
        return input;
    }
}

export function stripTags(text) {
    return text ? text.replace(/(<([^>]+)>)/ig, '') : text;
}

export function nl2br(str, isXhtml) {
    if(typeof str === 'undefined' || str === null) {
        return '';
    }
    const breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br />' : '<br>';
    return `${str}`.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
}

export function splitCamelCase(s) {
   return `${s}`.split(/([A-Z][a-z]+)/).filter(e => e);
}

export function removeEmojis(text) {
    return `${text}`
        .replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '')
        .replace(/[^\x00-\xFF]/g, '');
}

export function encodeText(text) {
    try {
        return encodeURIComponent(text);
    } catch (e) {
        console.error(e, text);
        return text;
    }
}

export function normalizeEmoji(text) {
    return uEmojiParser.parse(`${text || ''}`, {
        parseToHtml: true,
        emojiCDN: 'EMOJI_CDN',
    // }).replace(/EMOJI_CDN\/14.0.2\//g, 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/');
    }).replace(/EMOJI_CDN/g, 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/');
}

export function getRandomString(size = 10) {
    // polyfills.js
    if(typeof window !== 'undefined' && !window.crypto) {
        window.crypto = window.msCrypto;
    }

    return nanoid(size);
}

export function base64ToBlob(base64, type = 'application/octet-stream') {
	const binStr = atob(base64);
	const len = binStr.length;
	const arr = new Uint8Array(len);
	for(let i = 0; i < len; i += 1) {
		arr[i] = binStr.charCodeAt(i);
	}
	return new Blob([arr], { type });
}

export function escapeRegExp(str) {
	return `${str || ''}`.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
